// plugins/draw/DrawPlugin.ts

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "../../store/store";
import { useMapContext } from "../../core/MapContext";
import { createDrawingTool } from "./aoiToolFactory";
import { DrawAOIFeature } from "./types";
import { AOI_SOURCE_ID, buildDrawGeoJSON, EDIT_AOI_SOURCE_ID } from "./consts";

interface AOIPluginProps
{
  allowMoveActive?: boolean;
}
export const AOIPluginComponent = ({ allowMoveActive = true }: AOIPluginProps = {}) =>
{
  const { mode, features, editingFeatureId, featureToDelete, activeFeatureId } = useSelector(
    (state: RootState) => state.aoi,
  );
  let featureVisible = features?.filter((f: DrawAOIFeature) => f.visible);

  const {
    basemaps,
    selectedBasemap,
    view: mapView,
    mousePosition,
  } = useSelector((state: RootState) => state.map);

  const { layers } = useSelector((state: RootState) => state.layer);

  const dispatch = useDispatch();

  const { mapType, mapInstance } = useMapContext();

  useEffect(() =>
  {
    if (!mapInstance) return;

    const source = mapInstance.getSource(AOI_SOURCE_ID);
    if (source)
    {
      source.setData(buildDrawGeoJSON(features));
    }

  }, [features]);

  useEffect(() =>
  {
    if (!mapInstance) return;

    // if (mode === "NONE") return;

    const tool = createDrawingTool(
      mapInstance,
      mapType,
      mode,
      editingFeatureId,
      featureVisible,
      dispatch,
      layers,
      activeFeatureId,
      allowMoveActive
    );
    tool.activate();

    return () =>
    {
      tool.deactivate();
    };
  }, [mode, mapInstance, editingFeatureId, featureToDelete, selectedBasemap, allowMoveActive]);

  return null;
};
